// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ig-1";
export var dateTimeButtonsContainer = "_ig-6";
export var dateTimeInputContainer = "_ig-7";
export var dateTimeWrapper = "_ig-8";
export var disabledTile = "_ig-0";
export var header = "_ig-2";
export var line = "_ig-3";
export var snoozeOption = "_ig-4";
export var time = "_ig-5";
export var todayTile = "_ig-9";
export var wrapper = "_ig-a";